import type { FC } from 'react'
import styled from '@emotion/styled'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'
import ButtonText from '@segment/matcha/components/ButtonText'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import RegionalSegmentImage from './RegionalSegmentImage'

const copy = {
  overline: `Regional Segment`,
  heading: `Regional infrastructure`,
  description: `Segment is committed to our customers globally, which is why we offer regional infrastructure in both Europe and the United States. Regional Segment allows you to access tools and controls that help you practice good data etiquette and comply with EU data regulations like the GDPR.`,
}

const link = {
  text: `Learn about Regional Segment`,
  url: `/product/gdpr/`,
}

const RegionalSegment: FC = () => {
  const pageConfig = usePageConfig()
  return (
    <Wrapper id="regional-segment">
      <StyledSectionBase variant="2Col" copyVariant="narrow" reverse={true}>
        <SectionCopy>
          <CopyTextBase>
            <CopyText.Overline>{copy.overline}</CopyText.Overline>
            <CopyText.Heading variant="h2" tag="h3">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description variant="pLarge">{copy.description}</CopyText.Description>
            <LinkWrapper size="medium" tag="a" href={getAbsoluteUrl(link.url, pageConfig)} iconEnd={ChevronRightIcon}>
              {link.text}
            </LinkWrapper>
          </CopyTextBase>
        </SectionCopy>

        <Section.Contents>
          <RegionalSegmentImage />
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  display: grid;
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    padding-top: 45px;
  }
`

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      padding-top: 0;
      grid-template-areas:
        'contents'
        'copy';
    }
  }
`

const LinkWrapper = styled(ButtonText)`
  padding-top: 0;
`

const SectionCopy = styled(Section.Copy)`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
    justify-self: end;
    align-self: center;
  }
`

export default RegionalSegment
